export const showAlert = () => ({
  type: "SHOW_ALERT"
});

export const hideAlert = () => ({
    type: "HIDE_ALERT"
});

export default (state = false, action = {}) => {
    switch(action.type) {
        case "SHOW_ALERT":
            return state = true;
        case "HIDE_ALERT":
            return state = false;
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/setAlert.js